export const FEATURES = {
    ONSITE_SALES: 'onsite_sales',
    ONSITE_SALES_COUNTRY: 'onsite_sales_country',
    CHRISTMAS_THEME: 'christmas_theme',
    GIFTCARD_BANNER: 'gift_card_banner',
    CUSTOM_PROMOTION_REASON: 'custom_promotion_reason',
    ENGAGED_PRICE_PROMOTION: 'engaged_price_promotion',
    FARM_HAS_CUSTOM_EVENT_TAG: 'custom_event_tag_farm',
    HIVE_HAS_CUSTOM_EVENT_TAG: 'custom_event_tag_hive',
    HIVE_MEMBER_HAS_CUSTOM_EVENT_TAG: 'custom_event_tag_hive_member',
    PROFESSIONAL_PAYMENT_INFORMATIONS: 'professional_payment_informations',
    HAS_ACCESS_TO_COMMUNITY_MESSAGE_PAGE: 'has_access_to_community_message_page',
    HAS_ACCESS_TO_ADD_PRODUCT_ON_HIVE_PAGE: 'has_access_to_add_product_on_hive_page',
    HAS_ACCESS_TO_ADD_ALM_PRODUCT_ON_HIVE_PAGE: 'has_access_to_add_alm_product_on_hive_page',
    HAS_ACCESS_TO_SIMPLIFYSALE_HIGHLIGHT_BEST_WORST_PR:
        'has_access_to_simplify_sale_highlight_bestworstprod',
    HAS_ACCESS_TO_SIMPLIFY_SALE_PRODUCT_SELECTION: 'has_access_to_simplifySale_productSelection',
};

export default {
    isFeatureActive(featureName, entity) {
        if (entity && entity.get && entity.get('enabledFeatures')) {
            return entity.get('enabledFeatures').indexOf(featureName) !== -1;
        }
        if (entity && entity.enabledFeatures) {
            return entity.enabledFeatures.indexOf(featureName) !== -1;
        }
        return false;
    },
};
